import "./FullContainer.css"
import "./mobile.css"

function FullContainer({content}) {
  return <div className="full-container">
    {content}
  </div>;
}

export default FullContainer;
